/*
 * Vídeos de fondo (heros): que se reproduzcan solos y en bucle también cuando el navegador
 * bloquea el autoplay.
 *
 * iOS con el modo de bajo consumo (y algunos Android con ahorro de batería) ignora
 * `autoplay` aunque el vídeo vaya mudo, y enseña el botón de play encima. Aquí:
 *  - se intenta `play()` al cargar y cada vez que el vídeo vuelve a la pantalla;
 *  - si el navegador lo rechaza, se reintenta en el primer gesto del usuario (toque, clic,
 *    tecla), que sí cuenta como permiso para reproducir;
 *  - al volver a la pestaña se relanza.
 * No toca los vídeos de una diapositiva inactiva de un carrusel (el carrusel los pausa a
 * propósito) ni los que están ocultos.
 * Además marca el vídeo con `data-lej-playing` en cuanto avanza, para retirar el póster
 * (snippet `lej-video-poster`) que lo tapa mientras carga.
 * Afecta solo a los `<video data-lej-autoplay>`.
 */
(function () {
  if (window.lejVideoAutoplay) return;
  window.lejVideoAutoplay = true;

  var GESTURES = ['touchstart', 'touchend', 'pointerdown', 'click', 'keydown'];

  function videos() {
    return document.querySelectorAll('video[data-lej-autoplay]');
  }

  function playable(v) {
    if (!v.getClientRects().length) return false;
    var slide = v.closest('[data-index]');
    return !(slide && slide.className.indexOf('__slide') > -1 && !slide.classList.contains('is-active'));
  }

  function tryPlay(v) {
    if (!playable(v)) return;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('playsinline', '');
    if (!v.paused) return;
    var p = v.play();
    if (p && p.catch) p.catch(armGestures);
  }

  function playAll() {
    var list = videos();
    for (var i = 0; i < list.length; i++) tryPlay(list[i]);
  }

  var armed = false;
  function onGesture() {
    playAll();
    disarm();
  }
  function armGestures() {
    if (armed) return;
    armed = true;
    for (var i = 0; i < GESTURES.length; i++) {
      document.addEventListener(GESTURES[i], onGesture, { passive: true, capture: true });
    }
  }
  function disarm() {
    armed = false;
    for (var i = 0; i < GESTURES.length; i++) {
      document.removeEventListener(GESTURES[i], onGesture, { capture: true });
    }
  }

  // Marca el vídeo cuando ya pinta frames de verdad (no basta `playing`: iOS lo lanza antes
  // del primer frame). El CSS esconde entonces el póster que va encima (lej-video-poster).
  function markPlaying(v) {
    function onTime() {
      if (v.currentTime > 0) {
        v.setAttribute('data-lej-playing', '');
        v.removeEventListener('timeupdate', onTime);
      }
    }
    v.addEventListener('timeupdate', onTime);
    onTime();
  }

  // `<source media>` solo se evalúa al cargar: si la ventana cruza el breakpoint (tablet que
  // gira, ventana que cambia de tamaño, DevTools), el vídeo se queda con la fuente del otro
  // tamaño. Al cruzarlo, se vuelve a cargar para que elija la suya.
  function followMedia(v, after) {
    if (!window.matchMedia) return;
    var sources = v.querySelectorAll('source[media]');
    function wanted() {
      var all = v.querySelectorAll('source');
      for (var i = 0; i < all.length; i++) {
        var m = all[i].getAttribute('media');
        if (!m || window.matchMedia(m).matches) return all[i].src;
      }
      return '';
    }
    function onChange() {
      var src = wanted();
      if (!src || src === v.currentSrc) return;
      v.removeAttribute('data-lej-playing');
      v.load();
      markPlaying(v);
      after(v);
    }
    for (var i = 0; i < sources.length; i++) {
      var mq = window.matchMedia(sources[i].getAttribute('media'));
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  function watch(v) {
    if (v.dataset.lejAutoplayBound) return;
    v.dataset.lejAutoplayBound = '1';
    markPlaying(v);
    followMedia(v, tryPlay);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) tryPlay(entries[i].target);
        }
      }).observe(v);
    }
    tryPlay(v);
  }

  function init() {
    var list = videos();
    for (var i = 0; i < list.length; i++) watch(list[i]);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) playAll();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
